import { useCallback } from 'react'

import { type City, useLocationStore } from '@entities/Location'

import { useCartStore } from '@features/cart/model/useCartStore'
import { useAddressStore } from '@features/shipping-methods'

/*
  Selecting a city in the top bar is not just a label change: it switches the
  shop the cart and address stores work against. Shared by the site header and
  the landing header so both stay in sync.
*/
export function useCitySelect () {
  const { setCurrentCity } = useLocationStore()
  const { setShop: setCartShop } = useCartStore()
  const { setShopId: setAddressShop, setSelectedAddress } = useAddressStore()

  return useCallback((city: City) => {
    setCurrentCity(city)

    if (city.defaultShop?.id) {
      setAddressShop(city.defaultShop.id)
      setCartShop(city.defaultShop.id)

      /**
       * Just a small hack to skip opening slots modal on first adding to cart
       */
      setSelectedAddress({ isVirtual: true, address: city.defaultShop?.address ?? '' })
    }
  }, [ setCurrentCity, setAddressShop, setCartShop, setSelectedAddress ])
}
